import { Typography } from '@mui/material';

const Text = () => {
  return (
      <Typography
        variant='h4'
        sx={{
          fontSize: '6rem',
          fontFamily: 'Koulen',
          textAlign: 'center'
        }}
      >
        NEWS
      </Typography>
  );
}

export default Text;
